import {Component, OnDestroy, OnInit} from '@angular/core';
import {TemplateService} from '../../shared/services/template.service';
import {AuthenticationService} from '../../authentication/authentication.service';
import {UserLogin} from '../../shared/models/user.model';
import {Subject} from 'rxjs/Rx';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {

    isCollapse: boolean;
    isOpen: boolean;

    user: UserLogin;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private tplSvc: TemplateService, private authenticationService: AuthenticationService) {
    }

    ngOnInit(): void {
        this.tplSvc.isSideNavCollapseChanges
            .pipe(takeUntil(this.unsubscribe$)).subscribe(isCollapse => this.isCollapse = isCollapse);
        this.tplSvc.isSidePanelOpenChanges
            .pipe(takeUntil(this.unsubscribe$)).subscribe(isOpen => this.isOpen = isOpen);
        this.authenticationService.user
            .pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
            this.user = user;
        });
    }

    toggleSideNavCollapse() {
        this.isCollapse = !this.isCollapse;
        this.tplSvc.toggleSideNavCollapse(this.isCollapse);
    }

    onLogout() {
        this.authenticationService.logout();
    }

    goToKE() {
      const oldUrl = window.location.href;
      const url = new URL(oldUrl);
      url.hostname = 'admin.hanslimo.com';
      window.open(url.href);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
